import { render, staticRenderFns } from "./undoneDetails.vue?vue&type=template&id=55b3c738"
import script from "./undoneDetails.vue?vue&type=script&lang=js"
export * from "./undoneDetails.vue?vue&type=script&lang=js"
import style0 from "./undoneDetails.vue?vue&type=style&index=0&id=55b3c738&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports